<template>
  <el-main>
    <el-divider content-position="left">新增等级</el-divider>
     <el-row>
             <el-col :span="3"> 
              <div style="margin-top: 2px">
                <el-link icon="el-icon-edit">赋分等级名称</el-link><br>
                 <el-input v-model="NewDengji" placeholder="赋分等级名称"></el-input> 
              </div>
              </el-col>
     </el-row>
              <div style="margin-top: 2px">
                <el-link icon="el-icon-edit">赋分最高分</el-link><br>
                <el-input-number v-model="newmax"  :min="0" :max="100" controls-position="right" :controls="false" size="mini" label="赋分最高分"></el-input-number>
                
              </div>
              <div style="margin-top: 2px">
                <el-link icon="el-icon-edit">赋分最低分</el-link><br>
                <el-input-number v-model="newmin"   :min="0" :max="100" controls-position="right" :controls="false" size="mini" label="赋分最低分"></el-input-number>
                
              </div>
              <div style="margin-top: 2px">
                <el-link icon="el-icon-edit">赋分占比</el-link><br>
                <el-input-number v-model="newzhanbi"   :min="0" :max="100" controls-position="right" :controls="false" size="mini" label="赋分占比"></el-input-number>
                
              </div>
 
          <br>        
            <el-button @click="handleAddNewDengji"    type="primary" icon="el-icon-edit" >增加</el-button>


     <el-divider content-position="left">等级列表</el-divider>
      <el-row>
        <el-col :span="12">   
                <el-table
                      ref="singleTable"
                      :row-style="{height:'20px'}"
                      :cell-style="{padding:'0px'}"
                      :data="dengjiList"
                      border
                      stripe         
                      highlight-current-row
                      @current-change="handleCurrentChange"
                      style="width: 100%">


                      <el-table-column
                        prop="dengji"
                        label="赋分等级"
                        >
                      

                      </el-table-column>    

                      <el-table-column
                        prop="max_dj"
                        label="赋分最高分"
                        >
                      

                      </el-table-column>  

                      <el-table-column
                        prop="min_dj"
                        label="赋分最低分"
                        >
                      
                      </el-table-column>

                      <el-table-column
                        prop="zhanbi"
                        label="赋分占比"
                        >           

                      </el-table-column>          

                            

                    <el-table-column label="修改"
                      >
                          <template slot-scope="scope">
                          
                          <el-button 
                              size="mini"
                              type="text"
                              @click="editSelDengji(scope.$index, scope.row)">修改</el-button>
                      
                          </template>
                      </el-table-column>
                     <el-table-column label="删除"
                      >
                          <template slot-scope="scope">
                          
                          <el-button 
                              size="mini"
                              type="text"
                              @click="delSelDengji(scope.$index, scope.row)">删除</el-button>
                      
                          </template>
                      </el-table-column>

                </el-table>


                <el-divider content-position="left">修改等级{{  this.sel_dengji}}</el-divider>
              <div style="margin-top: 2px">
                <el-link icon="el-icon-edit">赋分最高分</el-link><br>
                <el-input-number v-model="max"  :min="0" :max="100" controls-position="right" :controls="false" size="mini" label="赋分最高分"></el-input-number>
                
              </div>
              <div style="margin-top: 2px">
                <el-link icon="el-icon-edit">赋分最低分</el-link><br>
                <el-input-number v-model="min"   :min="0" :max="100" controls-position="right" :controls="false" size="mini" label="赋分最低分"></el-input-number>
                
              </div>
              <div style="margin-top: 2px">
                <el-link icon="el-icon-edit">赋分占比</el-link><br>
                <el-input-number v-model="zhanbi"   :min="0" :max="100" controls-position="right" :controls="false" size="mini" label="赋分占比"></el-input-number>
                
              </div>
 
          <br>        
              <el-button @click="handleSaveDengjiSetting" :disabled="disabled"  type="primary" icon="el-icon-edit" >保存</el-button>          
        </el-col>
     </el-row> 
  </el-main>
  
  
</template>
<script>
import axios from 'axios'
import qs from 'qs'
  export default {
    data() {
      return {
        checkedXztReadOnly: false,
        checkedYzScannerJqm:false,
        checkedLogScannerInfo:false,
        noRegTip:'',
        dengjiList:[],
        max:'',
        min:'',
        zhanbi:'',
        sel_dengji:'',
        sel_id:'',
        disabled:true,
        NewDengji:'',
        newmax:'',
        newmin:'',
        newzhanbi:'',
    
      };
    },
  activated() {
			console.log('获取服务器设定列表');

      this.scannerList=[];
      this.noRegTip='';
      this.sel_id='';
      this.sel_dengji='';
      this.max='';
      this.min='';
      this.zhanbi='';
      this.disabled=true;
      this.getDengjiList();

	},
  methods: {

      editSelDengji(index, row) {

         let dengjiId=this.dengjiList[index]['id'];
         this.sel_id=this.dengjiList[index]['id'];
         this.sel_dengji=this.dengjiList[index]['dengji'];
         this.max=this.dengjiList[index]['max_dj'];
         this.min=this.dengjiList[index]['min_dj'];
         this.zhanbi=this.dengjiList[index]['zhanbi'];
         this.disabled=false;
         
  
      },

        delSelDengji(index, row) {

         let dengjiId=this.dengjiList[index]['id'];
            axios.post('/scoreman?op=delDengji',qs.stringify({"id":dengjiId})).then((res)=>{
                    console.log(res.data);    
                     
                    let rr=res.data;
                    if (rr['msg']=="ok")    
                    {
                      console.log("res.dataxxx"); 
                      this.$alert('删除成功', '提示', {
                          confirmButtonText: '确定'
                        });
                      this.getDengjiList();
                    }          

                    
                }).catch((res)=>{
                    console.log(response)
                })
         
  
      },
    getDengjiList()
    {	
        axios.get('/scoreman?op=fufendjlist').then((res)=>{
              console.log(res.data)
              this.dengjiList=res.data;
              
              
              
          }).catch((res)=>{
              console.log(response)
          })      

    },
     
        handleSaveDengjiSetting () {      
          
             let svrSetting='';   

              axios.post('/scoreman?op=saveDengjiSetting',qs.stringify({"id":this.sel_id,"max_dj":this.max,"min_dj":this.min,"zhanbi":this.zhanbi})).then((res)=>{
                    console.log(res.data);    
                     
                    let rr=res.data;
                    if (rr['msg']=="ok")    
                    {
                      console.log("res.dataxxx"); 
                      this.$alert('保存成功', '提示', {
                          confirmButtonText: '确定'
                        });
                      this.getDengjiList();
                    }          

                    
                }).catch((res)=>{
                    console.log(response)
                })
        },

            handleAddNewDengji () {      
          
             let svrSetting='';   

              axios.post('/scoreman?op=addNewDengji',qs.stringify({"dengji":this.NewDengji,"max_dj":this.newmax,"min_dj":this.newmin,"zhanbi":this.newzhanbi})).then((res)=>{
                    console.log(res.data);    
                     
                    let rr=res.data;
                    if (rr['msg']=="ok")    
                    {
                      this.NewDengji='';
                      this.newmax='';
                      this.newmin='';
                      this.newzhanbi='';
                      console.log("res.dataxxx"); 
                      this.$alert('新增成功', '提示', {
                          confirmButtonText: '确定'
                        });
                      this.getDengjiList();
                    }          

                    
                }).catch((res)=>{
                    console.log(response)
                })
        },
  },

  };
</script>